const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/politica-de-privacidade"],
    exact: true,
    component: "PrivacyPolicy"
  }
];

export default routes;
